module.exports = __webpack_public_path__ + "static/img/theatre_1.2802806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/theatre_1.jpg
// module id = 1KOR
// module chunks = 3